import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import React from 'react';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';

type Props = {
    baseUrl: string;
};

const MessagesPageHeaderMeta = ({ baseUrl }: Props) => {
    const { formatMessage } = useIntl();
    const title = useAddNotificationCountToTitle(formatMessage({ id: 'messaging.title' }));
    const description = formatMessage({
        id: 'exceptional_items_from_trusted_auction_houses',
    });
    const canonical = `${baseUrl}/dashboard/messages`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default MessagesPageHeaderMeta;
